export default "__VITE_ASSET__f79eae6e__"